(function (app, ng) {

    app.directive("inputFocus",
        [
            function () {
                return {
                    restrict: "A",
                    link: function (scope, element) {
                        var inputContainer = ng.element(element.parent());

                        element.on("focus",
                            function () {
                                inputContainer.addClass("input-focus");
                            });

                        element.on("blur",
                            function () {
                                inputContainer.removeClass("input-focus");
                            });
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line